import '../../../order_movement.css'

import { IconReceipt } from '@tabler/icons-react'
import { Button, type ButtonProps, Tooltip } from 'antd'
import React from 'react'

type DeliveryTicketButtonProps = {
  onClick: ButtonProps['onClick']
  numTickets: number
}

export function DeliveryTicketButton({ onClick, numTickets }: DeliveryTicketButtonProps) {
  return (
    <div className='vertical-flex-center p-8'>
      <Tooltip title='View Delivery Tickets' mouseEnterDelay={0.5} placement='top'>
        <Button
          className='info-button'
          shape='default'
          icon={<IconReceipt size={12} className='ticket-icon' />}
          disabled={numTickets === 0}
          onClick={onClick}
        >
          Tickets ({numTickets})
        </Button>
      </Tooltip>
    </div>
  )
}
